import { createAction } from 'redux-actions';
import localStore from 'store';
import * as actionType from './actionTypes';
import loadDbFeatureFlags from '../../helpers/loadFeatureFlags';

export const setFlags = createAction(actionType.SET_FLAGS);
export const setLoaded = createAction(actionType.SET_LOADED);

// Fetch DB feature flags and store them in Redux. Fails closed: with no JWT
// (user not signed in) or on fetch failure, flags resolve to an empty map so
// consumers fall back to their defaults (false). Never rejects. Dispatched once
// at startup and again after the user signs in (a new JWT is issued at login).
export const fetchFeatureFlags = () => async(dispatch, getState) => {
  // No JWT yet: fail closed with empty flags but mark as loaded.
  if (!localStore.get('jwt')) {
    dispatch(setFlags({}));
    dispatch(setLoaded(true));
    return;
  }

  // Only show the loading state on the first load. On subsequent refetches
  // (after sign-in or a session refresh) keep the already-loaded flags on
  // screen so flag-gated views don't blank out (stale-while-revalidate).
  if (!getState().data.featureFlags.loaded) {
    dispatch(setLoaded(false));
  }
  const flags = await loadDbFeatureFlags();
  dispatch(setFlags(flags));
  dispatch(setLoaded(true));
};
